<template>
    <b-row class="border-bottom flex-nowrap">
        <b-col
            v-for="wall in items"
            :key="wall.id"
            cols="auto"
        >
            <room-wall
                :component-id="componentId"
                :floor-id="floorId"
                :project-id="projectId"
                :room-id="roomId"
                :wall="wall"
                @update="onUpdated"
                @deleted="onDeleted"
            />
        </b-col>

        <b-col
            v-if="$gate.allow('create', 'wall')"
            cols="auto"
        >
            <b-form @submit.prevent="handleCreate">
                {{ $t('New Wall') }} ( {{ $t('Width') }})

                <b-form-group
                    :label="$t('Width')"
                    :label-for="'room_' + roomId + 'new_wall'"
                    label-sr-only
                >
                    <b-input-group append="m" size="sm">
                        <b-form-input
                            :id="'room_' + roomId + 'new_wall'"
                            ref="newWallInput"
                            v-model="form.width"
                            name="width"
                            type="number"
                            step="0.001"
                            style="width: 80px;"
                            size="sm"
                        />
                    </b-input-group>
                </b-form-group>
                <button v-show="false">
                    {{ $t('Create') }}
                </button>
            </b-form>
        </b-col>
    </b-row>
</template>
<script>
    import RoomWall from '@/components/floors/RoomWall';
    import {WALL_TYPES} from '@/constants';
    import fetchData from "@/mixins/fetchData";

    export default {
        name: 'RoomWalls',
        components: {RoomWall},
        props: {
            componentId: {
                type: [Number, String],
                required: true,
            },
            floorId: {
                type: [Number, String],
                required: true,
            },
            projectId: {
                type: [Number, String],
                required: true,
            },
            roomId: {
                type: [Number, String],
                required: true,

            },
            walls: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                form: {
                    type: WALL_TYPES.WALL
                },
                items: [],
                lazy: true
            };
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/rooms/${this.roomId}/walls`;
            },
        },
        watch: {
            walls: {
                handler(newWallsValue) {
                    this.items = newWallsValue;
                },
                immediate: true
            }
        },
        methods: {
            async handleCreate() {
                let newWall = await this.axios.post(this.apiUrl, this.form).then(({data}) => data);
                this.items.push(newWall);

                this.form.width = null;
                this.$nextTick(() => {
                    this.$refs.newWallInput.$el.scrollIntoView({block: 'nearest', inline: 'center'});
                });
            },

            onDeleted(wall) {
                let index = this.items.find(item => item.id === wall.id);
                this.items.splice(index, 1);
            },

            onUpdated(wall) {
                let index = this.items.find(item => item.id === wall.id);
                this.items.splice(index, 1, wall);
            },
        },
    };
</script>
